/* ============================================================
   WowSticker — WOWassistant inline chat (hero)
   Runs the SAME AI consultation as guide.js, but directly inside
   the hero card. No page scroll: the conversation happens here.
   ============================================================ */
(function(){
  'use strict';
  var card  = document.getElementById('wa-chat');
  var body  = document.getElementById('hc-body');
  var form  = document.getElementById('hc-form');
  var input = document.getElementById('wa-input');
  if(!card || !body || !form || !input) return;
  var restartBtn = document.getElementById('hc-restart');
  var introHTML = body.innerHTML;   // the welcome bubble, restored on reset

  var G = window.WowGuide || null;
  var CT = (window.WowCatalog && window.WowCatalog.META.contacts) || {};
  var messages = [];        // {role,text[,opts]} | {card:rec}
  var busy = false;
  var started = false;
  var gen = 0;              // stale-reply guard

  var esc = function(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); };

  // Ask the model: prima Cloudflare Workers AI (se WOWASSISTANT_WORKER_URL è
  // impostato), poi fallback a window.claude (anteprima Claude Design).
  async function askModel(prompt){
    var url = (window.WOWASSISTANT_WORKER_URL || '').trim();
    if(url && !/^https?:\/\//i.test(url)) url = 'https://' + url;   // tollera URL senza protocollo
    if(url){
      try{
        var resp = await fetch(url, { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify({ prompt: prompt }) });
        if(resp.ok){ var j = await resp.json(); var t = j.text || j.response; if(t) return t; }
      }catch(e){ /* worker offline → prova il fallback */ }
    }
    if(window.claude && window.claude.complete) return await window.claude.complete(prompt);
    throw new Error('no-ai');
  }

  function cardHtml(r, i){
    var why = r.reasons.slice(0,2).map(function(x){ return x.html; }).join(' ');
    var price = r.needsQuote
      ? '<div class="hc-price"><b>Su richiesta</b></div>'
      : '<div class="hc-price"><b>'+(r.estimate?'≈ ':'')+ G.fmt(r.total) +'</b><small>'+ G.fmt(r.unit) +' / pz'+(r.estimate?' · stima':'')+' · IVA incl.</small></div>';
    var contacts = r.contacts
      ? '<p class="hc-contacts">Preventivo: <a href="'+CT.whatsappUrl+'" target="_blank" rel="noopener">WhatsApp</a> · <a href="mailto:'+CT.supporto+'">'+CT.supporto+'</a></p>'
      : '';
    return '<div class="hc-prod">'+
      '<span class="hc-badge">La proposta per te</span>'+
      '<h4>'+ r.tipoLabel +'</h4>'+
      (why ? '<p class="hc-why">'+ why +'</p>' : '')+
      '<div class="hc-specs">'+
        '<span>'+ r.sizeLabel +'</span>'+
        '<span>'+ r.qty +' pz</span>'+
        (r.taglioLabel ? '<span>'+ r.taglioLabel +'</span>' : '')+
      '</div>'+
      price + contacts +
      '<button type="button" class="hc-go" data-i="'+ i +'">Vai al configuratore già impostato <span>›</span></button>'+
    '</div>';
  }

  function render(){
    body.classList.add('hc-mode');
    var last = messages[messages.length-1];
    var html = '<div class="hc-msgs" id="hc-msgs">';
    messages.forEach(function(m,i){
      html += m.card
        ? cardHtml(m.card, i)
        : '<div class="hc-msg '+(m.role === 'user' ? 'me' : 'ai')+'">'+ esc(m.text) +'</div>';
    });
    if(!busy && last && last.role === 'ai' && !last.card && last.opts && last.opts.length){
      html += '<div class="hc-quick">'+ last.opts.map(function(o,i){
        return '<button type="button" data-q="'+i+'">'+ esc(o) +'</button>';
      }).join('') +'</div>';
    }
    if(busy) html += '<div class="hc-typing"><i></i><i></i><i></i></div>';
    html += '</div>';
    body.innerHTML = html;

    var msgs = document.getElementById('hc-msgs');
    if(msgs) msgs.scrollTop = msgs.scrollHeight;
    input.disabled = busy;

    body.querySelectorAll('.hc-quick button').forEach(function(b){
      b.addEventListener('click', function(){
        if(busy) return;
        messages.push({ role:'user', text: last.opts[+b.dataset.q] });
        render(); askAI();
      });
    });
    body.querySelectorAll('.hc-go').forEach(function(b){
      b.addEventListener('click', function(){
        var r = messages[+b.dataset.i] && messages[+b.dataset.i].card;
        if(!r) return;
        var p = new URLSearchParams();
        if(r.taglio) p.set('taglio', r.taglio);
        if(r.size) p.set('size', r.size);
        if(r.qty)  p.set('qty', r.qty);
        if(r.w)    p.set('w', r.w);
        if(r.h)    p.set('h', r.h);
        var qs = p.toString();
        var base = (window.WowCatalog && window.WowCatalog.urlFor)
          ? window.WowCatalog.urlFor(r.tipo || 'vinile')
          : ('/products/' + (r.tipo || 'vinile'));
        window.location.href = base + (qs ? ('?' + qs) : '');
      });
    });
  }

  function start(seed){
    seed = (seed || '').trim();
    if(!seed || started) { if(seed){ messages.push({role:'user',text:seed}); render(); askAI(); } return; }
    started = true;
    window.__heroChatOn = true;             // stop the placeholder cycling
    card.classList.add('hc-on');            // hide the intro suggestion chips
    messages = [{ role:'user', text: seed }];
    render();
    askAI();
  }

  async function askAI(){
    var url = (window.WOWASSISTANT_WORKER_URL || '').trim();
    var hasAI = !!url || (window.claude && window.claude.complete);
    if(!G || !hasAI){
      busy = false;
      messages.push({ role:'ai', text:'In questo momento non riesco a rispondere qui. Usa la guida alla scelta più in basso: poche domande e arrivi comunque alla proposta giusta.' });
      render();
      return;
    }
    busy = true; render();
    var myGen = gen;
    var transcript = messages.filter(function(m){ return m.text; })
      .map(function(m){ return (m.role === 'user' ? 'CLIENTE: ' : 'ASSISTENTE: ') + m.text; }).join('\n');
    var out;
    try{
      var raw = await askModel(G.AI_GUIDE + '\n\nConversazione:\n' + transcript + '\n\nRispondi ora con il JSON.');
      if(myGen !== gen) return;
      out = G.parseAI(raw);
    }catch(e){
      if(myGen !== gen) return;
      busy = false;
      messages.push({ role:'ai', text:'Ops, non riesco a rispondere adesso. Riprova tra poco oppure usa la guida alla scelta qui sotto.' });
      render();
      return;
    }
    busy = false;
    var rec = out && out.recommend;
    var valid = G.validRec ? G.validRec(rec) : false;
    messages.push({
      role:'ai',
      text: (out && out.reply) ? String(out.reply) : 'Perfetto!',
      opts: (!valid && out && Array.isArray(out.options))
        ? out.options.filter(function(o){ return typeof o === 'string' && o.trim(); }).slice(0,4)
        : null
    });
    if(valid){
      messages.push({ role:'ai', card: G.buildCard(rec) });
    }
    render();
  }

  function reset(){
    gen++;                       // cancel any in-flight AI reply
    busy = false;
    started = false;
    messages = [];
    window.__heroChatOn = false;
    card.classList.remove('hc-on');
    body.classList.remove('hc-mode');
    body.innerHTML = introHTML;   // bring back the welcome bubble + suggestion chips
    input.value = '';
    input.disabled = false;
    try{ input.focus({ preventScroll:true }); }catch(e){ input.focus(); }
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    var v = input.value.trim();
    if(!v || busy) return;
    input.value = '';
    start(v);
  });

  card.querySelectorAll('.wa-chip').forEach(function(c){
    c.addEventListener('click', function(e){
      e.preventDefault();
      start(c.getAttribute('data-q') || c.textContent.trim());
    });
  });

  if(restartBtn) restartBtn.addEventListener('click', reset);

  /* ---- public hook: let other CTAs seed & focus the hero assistant ---- */
  window.WowHeroChat = {
    seed: function(text){
      var t = (text || '').trim();
      if(!t) { try{ input.focus(); }catch(e){} return; }
      start(t);
    },
    focus: function(){ try{ input.focus({ preventScroll:true }); }catch(e){ input.focus(); } }
  };
})();
